module.exports = __webpack_public_path__ + "img/delivery-np.29a02267.svg";